<app-widget-card-wrapper [title]="chartTitle" [subTitle]="chartSubtitle" [hide]="noData">
  <div *ngIf="noData === false" class="card-stretch text-center">
    <div [id]="id" echarts [options]="chartOptions" *ngIf="chartOptions" style="max-height: 317px"></div>
  </div>

  <section *ngIf="noData === false">
    <mat-select multiple [(value)]="selectedOptions" (selectionChange)="handleLocationListChange($event)">
      <mat-option *ngFor="let option of availableOptions" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>
  </section>

  <div *ngIf="noData === true" class="card-stretch text-center no-data-message">
    <h5>
      Kāore he raraunga? Kāore he raru!<br />Not seeing any data? No problem!<br /><br />
      These insights are fed by data from your Rongo App. Don’t forget to use your app if you are heading out into te
      taiao.
    </h5>
  </div>
</app-widget-card-wrapper>
